import type { Reply } from 'models';
import type { User } from 'features/auth';

export const canEditComment = ({ comment, viewer }: { comment: Reply; viewer: User }) =>
  viewer.railsUserData.id === comment.author.id;
